import { motion } from "framer-motion";
import { ReactNode } from "react";

/**
 * iOS-style horizontal page transition.
 * In RTL (Hebrew), new pages slide in from the left edge visually,
 * matching the iOS "back" gesture direction. In LTR, they slide in from the right.
 *
 * We detect direction from <html dir> at render time.
 */
const PageTransition = ({ children }: { children: ReactNode }) => {
  const isRtl = typeof document !== "undefined" && document.documentElement.dir === "rtl";
  const enterX = isRtl ? "-100%" : "100%";
  const exitX = isRtl ? "30%" : "-30%";

  return (
    <motion.div
      initial={{ x: enterX, opacity: 0.6 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: exitX, opacity: 0 }}
      transition={{
        x: { type: "tween", ease: [0.32, 0.72, 0, 1], duration: 0.35 },
        opacity: { duration: 0.25 },
      }}
      style={{ willChange: "transform, opacity" }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
